module.exports = __webpack_public_path__ + "img/reverse.4839e00c.svg";